/**
 * process.env.API_URL should be only this style.
 * When there other way it can be not replaced. For example: const { API_URL } = process.env
 */
import _ from 'lodash'
import invariant from 'invariant'
import configDev from './config.dev'

const isTest = process.env.NODE_ENV === 'test'
const version = process.env.VERSION
const app = process.env.APP

console.log(`
********************************************
******  APP: ${app} (${version})
********************************************
`)

export const ApiEncSec = '25b8f0c8-1693-46b2-bf68-bb5956b4d08b' // do not log with config object

let config = {
  version,
  env: process.env.APP_ENV,
  api_url: process.env.API_URL as string,
  assets_api_url: process.env.ASSETS_API_URL as string,
  hr_app_url: process.env.HR_APP_URL as string,

  timeout: process.env.APP_ENV === 'production' ? 120000 : 30000,

  PORT: 3366,
  bugsnag_api_key: '9023182271ff0d8ed8f8c1f4b92482a7',
  google_api_key: 'AIzaSyCaUJ8uieZIvOAlQGAcOOo99meQrbOa5MQ',

  links: {
    termsOfUse: 'https://www.reaction-club.com/termsofuse',
    privatePolicy: 'https://www.reaction-club.com/privacypolicy',
  },

  cmsFrameLink: process.env.CMS_URL as string,

  loggers: {
    isStoreEnabled: !isTest,
  },

  analytics: {
    isEnabled: app === 'production',
  },

  analyst: {
    key: 'f2c589f9-b202-4984-a252-4df2e6b15aef',
    url: 'https://analyst.reaction-club.app',
  },

  emails: {
    support: 'hello@reaction-club.com',
  },

  recaptchaSiteKey: '6Lee7dchAAAAAAWvOPaPwq1PTTtopObFEv-glg0G', // v3
}

if (config.env !== 'production') {
  config = _.merge(config, configDev)
}

if (!isTest) {
  console.log('env', config.env)
  console.log('config', config)
}

invariant(config.api_url, 'config.api_url is not set')

// @ts-ignore
window.config = config

export default config
